import { render, staticRenderFns } from "./crudSettings.vue?vue&type=template&id=0ae6c27a&"
import script from "./crudSettings.vue?vue&type=script&lang=js&"
export * from "./crudSettings.vue?vue&type=script&lang=js&"
import style0 from "./crudSettings.vue?vue&type=style&index=0&id=0ae6c27a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports